
import { defineComponent, onMounted, computed, ref, watchEffect } from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";
import ExpertDetailsCard from "@/components/cards/ExpertDetailsCard.vue";
import objectPath from "object-path";

export default defineComponent({
  name: "find-experts",
  components: {
    ExpertDetailsCard,
  },
  setup() {
    const store = useStore();
    const user = computed(() => store.getters.getUser);
    const founderRequisiteExperts = ref<Array<Record<string, unknown>>>([]);
    watchEffect(() => {
      founderRequisiteExperts.value = user.value.founderRequisiteExpert;
    });
    onMounted(async () => {
      setCurrentPageBreadcrumbs("Connected Experts", []);
    });

    return {
      founderRequisiteExperts,
    };
  },
});
